<template>
<div class="chapter">
<div class="inner_page">
<div class="_idgenobjectstyleoverride" id="_idContainer003">
<p class="structure-next" id="calibre_pb_8"> </p>
<p class="centered"> </p>
<p class="centered"> </p>
<p class="centered"> </p>
<p class="centered"> </p>
<p class="centered"> </p>
<p class="centered"> </p>
<p class="centered">For my children Alexandra and Jaime Lalinde</p>
<p class="centered">who keep showing me how to live life courageously.</p>
<p class="centered"> </p>
<div class="calibre2" id="calibre_pb_9"></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ebook_split_004.vue?6eaae444